module.exports = __webpack_public_path__ + "static/img/9.7811e21.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/sp/9.png
// module id = 5KAt
// module chunks = 0